import { render, staticRenderFns } from "./RadioDemonstrativoField.vue?vue&type=template&id=1abb338a&scoped=true&"
import script from "./RadioDemonstrativoField.vue?vue&type=script&lang=js&"
export * from "./RadioDemonstrativoField.vue?vue&type=script&lang=js&"
import style0 from "./RadioDemonstrativoField.vue?vue&type=style&index=0&id=1abb338a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb338a",
  null
  
)

export default component.exports